import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub_title_01" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["innerHTML"]

import { ref, onMounted } from "vue";

interface Props {
  title: string;
  subtitle?: string;
  description?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    title: {},
    subtitle: { default: "" },
    description: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const animateP = ref(false);
const animateH2 = ref(false);

onMounted(() => {
  setTimeout(() => {
    animateP.value = true;
  }, 300);
  setTimeout(() => {
    animateH2.value = true;
  }, 700);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: _normalizeClass({ animateP: animateP.value })
        }, _toDisplayString(_ctx.subtitle), 3),
        _createElementVNode("h2", {
          class: _normalizeClass({ animateH2: animateH2.value }),
          innerHTML: _ctx.description
        }, null, 10, _hoisted_4)
      ])
    ])
  ]))
}
}

})